import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=639e3b5e&scoped=true&"
import script from "./TreeSelect.vue?vue&type=script&lang=js&"
export * from "./TreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./TreeSelect.vue?vue&type=style&index=0&id=639e3b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e3b5e",
  null
  
)

export default component.exports